import { request } from '../helpers/request';
import {
  PaginatedResponse,
  Translation,
  TranslationStatus,
  TranslationVersion,
} from '../helpers/types';

export interface AiTranslationOutcome {
  language: string;
  status: 'translated' | 'skipped';
  value?: string;
  reason?: string;
}

export interface TranslateMissingResult {
  translated: number;
  skipped: number;
  languages: string[];
}

export type ListTranslationsParams = {
  language?: string;
  status?: TranslationStatus;
  page?: number;
  limit?: number;
  search?: string;
};

export const translationsApi = {
  list: (projectId: string, params: ListTranslationsParams = {}) =>
    request<PaginatedResponse<Translation>>(
      `/projects/${projectId}/translations`,
      { params },
    ),

  listForKey: (projectId: string, keyId: string) =>
    request<Translation[]>(
      `/projects/${projectId}/keys/${keyId}/translations`,
    ),

  upsert: (
    projectId: string,
    keyId: string,
    language: string,
    value: string,
  ) =>
    request<Translation>(
      `/projects/${projectId}/keys/${keyId}/translations/${language}`,
      { method: 'PUT', body: { value } },
    ),

  translateKey: (
    projectId: string,
    keyId: string,
    payload: { languages?: string[]; overwriteApproved?: boolean },
  ) =>
    request<AiTranslationOutcome[]>(
      `/projects/${projectId}/keys/${keyId}/translate`,
      { method: 'POST', body: payload },
    ),

  translateMissing: (
    projectId: string,
    payload: { languages?: string[]; retranslateRejected?: boolean },
  ) =>
    request<TranslateMissingResult>(
      `/projects/${projectId}/translate-missing`,
      { method: 'POST', body: payload },
    ),

  review: (
    projectId: string,
    translationId: string,
    payload: { decision: 'approve' | 'reject'; note?: string },
  ) =>
    request<Translation>(
      `/projects/${projectId}/translations/${translationId}/review`,
      { method: 'POST', body: payload },
    ),

  versions: (projectId: string, translationId: string) =>
    request<TranslationVersion[]>(
      `/projects/${projectId}/translations/${translationId}/versions`,
    ),
};
